const wiki = {
  search: "חפש בויקי...",
  allCategories: "כל הקטגוריות",
  newEntry: "ערך חדש",
  noEntries: "אין ערכים בויקי",
  noEntriesDesc: "צור ערך ראשון כדי להתחיל לבנות את בסיס הידע",
  noResults: "לא נמצאו תוצאות",
  tryDifferentSearch: "נסה מילות חיפוש אחרות",
  title: "כותרת",
  description: "תיאור",
  category: "קטגוריה",
  qaPairs: "שאלות ותשובות",
  question: "שאלה",
  answer: "תשובה",
  addQaPair: "הוסף שאלה ותשובה",
  removeQaPair: "הסר",
  save: "שמור",
  saving: "שומר...",
  saved: "נשמר",
  cancel: "ביטול",
  create: "צור ערך",
  creating: "יוצר...",
  backToWiki: "חזרה לויקי",
  editEntry: "ערוך ערך",
  deleteEntry: "מחק ערך",
  confirmDelete: "למחוק את הערך לצמיתות?",
  entries: "ערכים",
  lastUpdated: "עודכן לאחרונה",
  uncategorized: "ללא קטגוריה",
  titleRequired: "כותרת הינה שדה חובה",
  categories: {
    sales: "מכירות",
    ops: "תפעול",
    tech: "טכנולוגיה",
    people: "אנשים",
    products: "מוצרים",
  },
} as const;
export default wiki;
